export default function GRReportInstancesController() { /* provided only for controllerAs binding */ }
